import { render } from "./TheBeginning.vue?vue&type=template&id=9da8393a&scoped=true"
import script from "./TheBeginning.vue?vue&type=script&lang=js"
export * from "./TheBeginning.vue?vue&type=script&lang=js"

import "./TheBeginning.vue?vue&type=style&index=0&id=9da8393a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9da8393a"]])

export default __exports__